import { render, staticRenderFns } from "./MemberGroup.vue?vue&type=template&id=5477166b&"
import script from "./MemberGroup.vue?vue&type=script&lang=ts&"
export * from "./MemberGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports